import React from "react";
import styled from "styled-components";
import {devices} from "../../styles/devices";
import {Typography} from "../typography";
import HorizontalContentBlock from "../content-block-horizontal";
import Media from "../media/media";


const ItemTitle = styled.h2`
  ${Typography.BaseHeadingMixin};

  color: var(--color-blue);
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.2em;

  @media ${devices.tablet} {
    font-size: 1.4rem;
  }
`;

const Icon = styled.img`
  margin-top: 0.3rem;
  width: 40px;

  @media ${devices.tablet} {
    width: 60px;
  }
`;

const FeatureItem = ({icon, title, text, className}) => {
    return (
        <li className={[className, text ? 'has-text': ''].join(' ')}>
            {icon && <Icon width="150" height="150" alt='Icon' src={icon.publicURL}></Icon>}
            <div className='details'>
                <ItemTitle>{title}</ItemTitle>
                {text && <p>{text}</p>}
            </div>
        </li>
    )
}

const StyledFeatureItem = styled(FeatureItem)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: calc(var(--content-spacing) / 2);
  text-align: start;
  
  &.has-text {
    align-items: flex-start;
  }
  
  .details {
    flex: 1;
  }

  @media ${devices.tablet} {
    gap: var(--content-spacing);
  }
`;

const FeaturesList = ({items, ...props}) => {
    return (
        <ul {...props}>
            {items.map((item, i) => <StyledFeatureItem key={i} {...item}></StyledFeatureItem>)}
        </ul>
    )
}

const StyledFeaturesList = styled(FeaturesList)`
  display: flex;
  flex-direction: column;
  gap: var(--content-spacing);
`;

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5em;
`;

const FeatureHighlightsBlock = ({content, items, media, ...props}) => {
  return (
    <HorizontalContentBlock
      contentPosition='left'
      content={<StyledContent>
        {content && <p>{content}</p>}
        <StyledFeaturesList items={items}/>
      </StyledContent>}
      media={<Media {...media} />}
      {...props}
    />
  )
}

export default FeatureHighlightsBlock
